import { Col, Select, Typography } from "antd"
import React, { useEffect, useMemo } from "react"

import {
  FiftyMmOptions,
  hundredFiftyMmOption,
  seventyMmOption,
  thirtySevenMmOption,
  twentyFiveNineHundredOption,
  twentyMmOption,
} from "./PriceSection/TapeOptions"

import {
  fiftyMm250mOption1Color,
  fiftyMm250mOption2Color,
  fiftyMm250mOption3Color,
  seventyFiveMm250mOption1,
  seventyFiveMm250mOption2,
  seventyFiveMm250mOption3,
  oneHundredMm250mOption1,
  oneHundredMm250mOption2,
  oneHundredMm250mOption3,
  seventyFiveTwoHundred,
  oneHundredFiftyMm250mOption1,
  oneHundredFiftyMm250mOption2,
  oneHundredFiftyMm250mOption3,
  seventyFiveHundred,
} from "./PriceSection/SignalOptions"

import { useCollection } from "../../hooks/useCollection"

const { Text } = Typography

const TAPE_ROLL_SIZES = [
  { value: 25, label: "25mm x 66m" },
  { value: 990, label: "25mm x 990m" },
  { value: 37.5, label: "37,5mm x 66m" },
  { value: 50, label: "50mm x 66m" },
  { value: 75, label: "75mm x 66m" },
  { value: 150, label: "150mm x 66m" },
]

const SIGNAL_ROLL_SIZES = [
  { value: 50, label: "50mm x 250m" },
  { value: 70, label: "75mm x 200m" },
  { value: 75, label: "75mm x 250m" },
  { value: 100, label: "100mm x 250m" },
  { value: 150, label: "150mm x 250m" },
  { value: 76, label: "75mm x 100m" },
]

const getColorOptionIndex = (colorCount) => {
  if (colorCount <= 1) return 1
  if (colorCount === 2) return 2
  return 3
}

export default function TapeLayout({
  tapeWidth,
  setTapeWidth,
  tapeMaterial,
  setTapeMaterial,
  setTapeOptions,
  setTapePrices,
  tapeColorCount,
}) {
  const { data: materialData, loading: materialLoading } = useCollection(
    "materials",
    ["stock", "==", true],
    ["materialFor", "==", "Tapes"],
  )

  const isSignalTape = tapeMaterial && tapeMaterial.material === "PE (Signal Tape)"

  const rollSizeOptions = useMemo(() => {
    return isSignalTape ? SIGNAL_ROLL_SIZES : TAPE_ROLL_SIZES
  }, [isSignalTape])

  // Signal tape pricing (depends on width + color count)
  useEffect(() => {
    if (!isSignalTape) return
    if (!tapeWidth) return

    const colorOption = getColorOptionIndex(tapeColorCount)

    const SIGNAL_PRICE_MAP = {
      50: {
        1: fiftyMm250mOption1Color,
        2: fiftyMm250mOption2Color,
        3: fiftyMm250mOption3Color,
      },
      75: {
        1: seventyFiveMm250mOption1,
        2: seventyFiveMm250mOption2,
        3: seventyFiveMm250mOption3,
      },
      100: {
        1: oneHundredMm250mOption1,
        2: oneHundredMm250mOption2,
        3: oneHundredMm250mOption3,
      },
      150: {
        1: oneHundredFiftyMm250mOption1,
        2: oneHundredFiftyMm250mOption2,
        3: oneHundredFiftyMm250mOption3,
      },
      70: seventyFiveTwoHundred,
      76: seventyFiveHundred,
    }

    const entry = SIGNAL_PRICE_MAP[tapeWidth]
    if (!entry) return

    const nextOptions = Array.isArray(entry) ? entry : entry[colorOption]

    if (nextOptions) {
      setTapeOptions(nextOptions)
      setTapePrices([])
    }
  }, [isSignalTape, tapeWidth, tapeColorCount, setTapeOptions, setTapePrices])

  const handleTapeMaterial = (option) => {
    setTapeMaterial(option)
    setTapeWidth(0)
    setTapePrices([])
  }

  const handleTapeWidth = (value) => {
    setTapeWidth(value)

    // For signal tape, options are controlled by the useEffect above
    if (isSignalTape) {
      setTapePrices([])
      return
    }

    // Normal tape options (switch)
    switch (value) {
      case 25:
        setTapeOptions(twentyMmOption)
        break
      case 37.5:
        setTapeOptions(thirtySevenMmOption)
        break
      case 50:
        setTapeOptions(FiftyMmOptions)
        break
      case 75:
        setTapeOptions(seventyMmOption)
        break
      case 150:
        setTapeOptions(hundredFiftyMmOption)
        break
      case 990:
        setTapeOptions(twentyFiveNineHundredOption)
        break
      default:
        setTapeOptions([])
        break
    }

    setTapePrices([])
  }

  return (
    <>
      <Col span={10}>
        <Text>Material :</Text>
      </Col>
      <Col span={14}>
        <Select
          placeholder="none"
          loading={materialLoading}
          onChange={(value, option) => handleTapeMaterial(option)}
          fieldNames={{ label: "material", value: "material" }}
          style={{ width: "100%" }}
          options={materialData}
        />
      </Col>

      <Col span={10}>
        <Text>Roll Size :</Text>
      </Col>
      <Col span={14}>
        <Select
          placeholder="0"
          value={tapeWidth}
          onChange={handleTapeWidth}
          style={{ width: "100%" }}
          options={rollSizeOptions}
        />
      </Col>
    </>
  )
}
